import { render, staticRenderFns } from "./StepsIndicator.vue?vue&type=template&id=6be49c80"
import script from "./StepsIndicator.vue?vue&type=script&lang=js"
export * from "./StepsIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports